import React, { useCallback, useEffect, useState } from "react";
import SelectPlan from "../../components/sections/select-plan";
import Steps from "../../components/elements/steps";
import { useAppStore } from "../../store";
import { useNavigate } from "react-router-dom";
import DataProvider from "../../services";
import { Stepx } from "../../utils/data";
import { Card } from "antd";
import img from "../../assets/images/nr1.jpg";

export default function PickAPlan() {
  const { user, setPackage, packages } = useAppStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<any>();
  const [plan, setPlan] = useState<any>();

  useEffect(() => {
    if (!user) {
      navigate("/sign-up");
    }
  }, [user, navigate]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await DataProvider.getAllPackages();
      setPackage(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [setPackage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="w-full h-full">
      {/* MOBILE VIEW */}
      <div
        className="h-screen lg:hidden flex flex-col w-full bg-cover bg-center bg-[#1A94ECB5] bg-blend-overlay relative"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="flex-1 overflow-y-auto px-4 py-6">
          <Card className="shadow-xl border-0 rounded-3xl bg-white/95 backdrop-blur-sm">
            <Steps current={1} items={Stepx} />
            <div className="mt-6">
              <SelectPlan
                plan={plan}
                setPlan={setPlan}
                packages={packages}
                setLoading={setLoading}
                loading={loading}
              />
            </div>
          </Card>
        </div>
      </div>

      {/* DESKTOP VIEW */}
      <div className="h-screen w-full lg:flex hidden">
        {/* Left Side - Branding */}
        <div
          className="h-full w-[50%] bg-center relative flex flex-col justify-between p-8 bg-cover bg-[#1A94ECB5] bg-blend-overlay"
          style={{ backgroundImage: `url(${img})` }}
        >
          <div className="relative z-10 text-white">
            <h1 className="text-6xl font-bold mb-4 leading-tight">
              Choose Your Plan
            </h1>
            <p className="text-2xl font-light opacity-90">
              Select the perfect plan for your health needs
            </p>
          </div>
        </div>

        {/* Right Side - Plans */}
        <div className="h-full w-[50%] flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-blue-50 p-12 overflow-y-auto">
          <div className="w-full max-w-2xl">
            <Card className="shadow-2xl border-0 rounded-3xl p-10 bg-white/95 backdrop-blur-sm">
              <div className="mb-8">
                <Steps current={1} items={Stepx} />
              </div>
              <SelectPlan
                plan={plan}
                setPlan={setPlan}
                packages={packages}
                setLoading={setLoading}
                loading={loading}
              />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
